import { BlackoutTypes } from 'enums';

/**
 * @param {object} location
 * @param {array} blackouts - destrctured from content {object}
 * Destructures a blackout array from content and checks for blackouts
 * against user location
*/
export default function locationBlackedOutForContent(location = {}, { blackouts = [] }) {
    return blackouts.filter((blackout) => {
        switch (blackout.type) {
            case BlackoutTypes.DMA:
                return ((blackout.detail || []).indexOf(location.dma) !== -1);
                break;
            case BlackoutTypes.DEVICE:
                // #TODO: implement when live content is support on mobile
                return false;
                break;
            default:
                return false;
        }
    }).length > 0;
};



// WEBPACK FOOTER //
// ./app/lib/auth/locationBlackedOutForContent.js